import fields from "../global/fields";
import Buefy from "buefy";
import { library } from "@fortawesome/fontawesome-svg-core";
import sharedMixins from "../mixins/sharedMixins";
import energieausweisErstellenOnlineDeMixins from "../mixins/energieausweisErstellenOnlineDeMixins";
import { denyUrls, ignoredErrors } from "../global/errorConfig"; // Import the new config
// internal icons
import {
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faArrowUp,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faCircle,
  faCopy,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExternalLinkAlt,
  faFile,
  faHome,
  faInfo,
  faInfoCircle,
  faMinus,
  faMousePointer,
  faPaperPlane,
  faPercent,
  faPlus,
  faQuestionCircle,
  faSave,
  faShoppingCart,
  faStar,
  faStickyNote,
  faTrash,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueRouter from "vue-router";
import _ from "lodash";
import axios from "axios";
import VueMoment from "vue-moment";
import $ from "jquery";
import VueGtag, { bootstrap } from "vue-gtag";
import "@babel/polyfill";
import VueClipboard from "vue-clipboard2";
import CookieLaw from "vue-cookie-law";
import { extend, localize, ValidationObserver, ValidationProvider } from "vee-validate";
import de from "vee-validate/dist/locale/de.json";
import * as rules from "vee-validate/dist/rules";
// import {Notifier} from '@airbrake/browser';
import VueLazyComponent from "@xunlei/vue-lazy-component";
import FileSelector from "vue-file-selector";
import moment from "moment/moment";
import Vue from "vue";
import GmapVue from "gmap-vue";
import * as Sentry from "@sentry/vue";
import { createPinia, PiniaVuePlugin } from "pinia";

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
window.Vue = require("vue").default;
window.$ = window.jQuery = $;
window._ = _;
//require('./bootstrap');

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  defaultFirstDayOfWeek: 1,
  defaultDateFormatter: date => date.toLocaleDateString("de-DE")
});

library.add(faUpload, faHome, faQuestionCircle, faArrowRight, faChevronDown, faExclamationCircle, faStar, faAngleRight, faAngleLeft, faCheck, faMinus, faPlus, faEdit,
  faTrash, faInfo, faInfoCircle, faCheckCircle, faDownload, faFile, faSave, faTrash, faPaperPlane, faCopy, faShoppingCart, faMousePointer, faStickyNote, faArrowUp,
  faShoppingCart, faCircle, faPercent, faExternalLinkAlt);

Vue.component("vue-fontawesome", FontAwesomeIcon);

Vue.use(VueMoment);

Vue.use(VueClipboard);
Vue.use(VueLazyComponent);
Vue.use(FileSelector);

// Global mixins
Vue.mixin({
  mixins: [sharedMixins, energieausweisErstellenOnlineDeMixins],
  methods: {
    // Add any additional methods specific to this app.js file here
  }
});

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("de", de);

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
extend("stringAndNumber", {
  message: field => {
    return "Hausnummer angeben.";
  },
  validate: value => {
    // https://regex101.com/r/cW5nP4/1
    const regex = new RegExp("(?=.*?[0-9])(?=.*?[A-Za-z]).+", "i");
    let m = regex.exec(value);
    if (m !== null)
      return true;
  }
});
extend("atMostOne1", {
  message: field => {
    return "Bitte wählen Sie nur eine Lüftungsanlage";
  },
  validate: (value, values) => {
    // Count the number of elements with value 1
    let count = values.reduce((acc, curr) => curr === 1 ? acc + 1 : acc, 0);

    if (count <= 1) {
      return { required: false, valid: true };
    }

    return { required: true, valid: false };
  }
});
extend("altLeastOne1", {
  message: field => {
    return "Bitte treffen Sie eine Auswahl.";
  },
  validate: (value, values) => {
    // Some values are truthy/present
    if (values.some(function(e) {
      return e === 1;
    })) {
      return { required: false, valid: true };
    }

    return { required: true, valid: false };
  }
});

extend("altLeastOne1Countable", {
  message: field => {
    return "Bitte treffen Sie eine Auswahl.";
  },
  validate: (value, values) => {
    // Some values are truthy/present
    if (values.some(function(e) {
      return e > 0;
    })) {
      return { required: false, valid: true };
    }

    return { required: true, valid: false };
  }
});

// window.axios = axios;
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const token = document.head.querySelector("meta[name=\"csrf-token\"]");
//window.axios.defaults.withCredentials = true;

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}

Vue.use(VueRouter);
const router = new VueRouter({
  mode: `history`,
  routes: []
});

window.fieldcodes = fields;

window.router = router;
window.EventBus = require("../global/Eventbus").EventBus;
window.EventBusManagement = require("../global/Eventbus").EventBusManagement;

// https://gist.github.com/reinink/a18985cee35a41f3a63585c043926981
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("CookieLaw", CookieLaw);

Vue.component("form-component", () => import("../products/FormComponent.vue"));
Vue.component("modal-legal", () => import("../products/Energieausweis/formular/checkout-partials/legalModal.vue"));
Vue.component("page1-picture-management", () => import("../products/Energieausweis/pdf_partials/partials/page1PictureManagementModal.vue"));
Vue.component("navigationMobileComponent", () => import("../products/Energieausweis/formular/partials/navigationMobileComponent"));
Vue.component("rightHelptextColumn", () => import("../products/Energieausweis/formular/partials/rightHelptextColumn"));
Vue.component("helpFormLabel", () => import("../products/Energieausweis/formular/partials/helpFormLabel.vue"));
Vue.component("Step1VA", () => import("../products/Energieausweis/formular/VA/Step1VA"));
Vue.component("Step2VA", () => import("../products/Energieausweis/formular/VA/Step2VA"));
Vue.component("Step3VA", () => import("../products/Energieausweis/formular/VA/Step3VA"));
Vue.component("Step4VA", () => import("../products/Energieausweis/formular/VA/Step4VA"));
Vue.component("Step1BA", () => import("../products/Energieausweis/formular/BA/Step1BA"));
Vue.component("Step2BA", () => import("../products/Energieausweis/formular/BA/Step2BA"));
Vue.component("Step3BA", () => import("../products/Energieausweis/formular/BA/Step3BA"));
Vue.component("Step4BA", () => import("../products/Energieausweis/formular/BA/Step4BA"));
Vue.component("Step5BA", () => import("../products/Energieausweis/formular/BA/Step5BA"));
Vue.component("quiz_product_chooser", () => import("../products/Energieausweis/partials/quiz_product_chooser"));
Vue.component("DataOverview", () => import("../products/Energieausweis/formular/DataOverview"));
Vue.component("Checkout", () => import("../products/Energieausweis/formular/Checkout"));
Vue.component("OrderConfirmationPage", () => import("../products/Energieausweis/formular/OrderConfirmationPage"));
Vue.component("HelpModal", () => import("../products/Energieausweis/formular/partials/helpModal.vue"));
Vue.component("CustomerNoticeAndAdditionalDocs", () => import("../products/Energieausweis/formular/partials/customerNoticeAndAdditionalDocs.vue"));
Vue.component("CustomerNoticeAndAdditionalDocsModal", () => import("../products/Energieausweis/formular/partials/customerNoticeAndAdditionalDocsModal.vue"));
Vue.component("Steps", () => import("../products/Energieausweis/formular/Steps"));
Vue.component("EnergieausweisHeader", () => import("../products/Energieausweis/pdf_partials/partials/EnergieausweisHeader.vue"));
Vue.component("EnergieausweisBox", () => import("../products/Energieausweis/pdf_partials/partials/EnergieausweisBox.vue"));
Vue.component("Energy_scale", () => import("../products/Energieausweis/pdf_partials/partials/energy_scale.vue"));
Vue.component("EnergieausweisSubTitle", () => import("../products/Energieausweis/pdf_partials/partials/EnergieausweisSubTitle.vue"));

// Formular
Vue.component("FormInformationCarousel", () => import("../products/Energieausweis/formular/partials/FormInformationCarousel.vue"));
Vue.component("rightHelptextColumn", () => import("../products/Energieausweis/formular/partials/rightHelptextColumn"));
Vue.component("EnergieausweisView", () => import("../products/Energieausweis/view_helper/EnergieausweisView.vue"));
Vue.component("FormStep1VA", () => import("../products/Energieausweis/formular/VA/partials/FormStep1VA"));
Vue.component("FormPropertyDimensions", () => import("../products/Energieausweis/formular/BA/partials/FormPropertyDimensions"));
Vue.component("FormPropertyInformations", () => import( "../products/Energieausweis/formular/VA/partials/FormPropertyInformations"));
Vue.component("FormRenewableEnergyUsage", () => import( "../products/Energieausweis/formular/form-partials/FormRenewableEnergyUsage"));
Vue.component("FormAircondition", () => import("../products/Energieausweis/formular/VA/partials/FormAircondition"));
Vue.component("FormVacant", () => import("../products/Energieausweis/formular/VA/partials/FormVacant"));
Vue.component("FormVaBasement", () => import("../products/Energieausweis/formular/VA/partials/FormVaBasement"));
Vue.component("FormVaOptionalQuestions", () => import( "../products/Energieausweis/formular/VA/partials/FormVaOptionalQuestions"));
Vue.component("FormObjectAddress", () => import("../products/Energieausweis/formular/form-partials/FormObjectAddress"));
Vue.component("FormObjectJamb", () => import("../products/Energieausweis/formular/form-partials/FormObjectJamb"));
Vue.component("FormFileupload", () => import("../products/Energieausweis/formular/BA/partials/FormFileuploadProperty"));
Vue.component("HelpModal", () => import("../products/Energieausweis/formular/partials/helpModal.vue"));
Vue.component("FormFileuploadBA", () => import("../products/Energieausweis/formular/BA/partials/FormFileuploadBA"));
Vue.component("FormFileuploadPropertyVA", () => import("../products/Energieausweis/formular/VA/partials/FormFileuploadPropertyVA"));
Vue.component("FormEnergyUsage1", () => import("../products/Energieausweis/formular/VA/partials/FormEnergyUsage1"));
Vue.component("FormEnergyUsage2", () => import("../products/Energieausweis/formular/VA/partials/FormEnergyUsage2"));
Vue.component("FormWaterHeating", () => import("../products/Energieausweis/formular/VA/partials/FormWaterHeating"));
Vue.component("FormWaterHeating2", () => import("../products/Energieausweis/formular/VA/partials/FormWaterHeating2"));
Vue.component("FormEnergyConsumption", () => import("../products/Energieausweis/formular/VA/partials/FormEnergyConsumption"));
Vue.component("FileUpload", () => import("../products/Energieausweis/formular/partials/fileUpload"));
Vue.component("FormMeasurement", () => import("../products/Energieausweis/formular/BA/partials/FormMeasurement"));
Vue.component("FormBasement", () => import("../products/Energieausweis/formular/BA/partials/FormBasement"));
Vue.component("PropertyOrientationPartial", () => import("../products/Energieausweis/formular/BA/partials/PropertyOrientationPartial"));
Vue.component("FormRoofSecondFloor", () => import("../products/Energieausweis/formular/BA/partials/FormRoofSecondFloor"));
Vue.component("FormPropertyMounted", () => import("../products/Energieausweis/formular/BA/partials/FormPropertyMounted"));
Vue.component("google-maps-partial", () => import("../app_immobilienwerker_de/partials/googleMapsPartial"));

Vue.component("FormWindows", () => import("../products/Energieausweis/formular/BA/partials/FormWindows"));
Vue.component("FormWindows2", () => import("../products/Energieausweis/formular/BA/partials/FormWindows2"));
Vue.component("FormRoof", () => import("../products/Energieausweis/formular/BA/partials/FormRoof"));
Vue.component("FormRoofDormers", () => import("../products/Energieausweis/formular/BA/partials/FormRoofDormers"));
Vue.component("FormRoofAdditionalInformations", () => import("../products/Energieausweis/formular/BA/partials/FormRoofAdditionalInformations"));
Vue.component("FormHeating2AdditionalInformations", () => import("../products/Energieausweis/formular/BA/partials/FormHeating2AdditionalInformations"));
Vue.component("FormObjectInformations", () => import("../products/Energieausweis/formular/BA/partials/FormObjectInformations"));
Vue.component("FormStep1BA", () => import("../products/Energieausweis/formular/BA/partials/FormStep1BA"));
Vue.component("FormObjectAnnex", () => import("../products/Energieausweis/formular/form-partials/FormObjectAnnex"));
Vue.component("uValues", () => import("../products/Energieausweis/formular/form-partials/uValues"));
Vue.component("FormRoofWindows", () => import("../products/Energieausweis/formular/BA/partials/FormRoofWindows"));
Vue.component("FormHeatingInformation", () => import("../products/Energieausweis/formular/BA/partials/FormHeatingInformation"));
Vue.component("FormHeating2Information", () => import("../products/Energieausweis/formular/BA/partials/FormHeating2Information"));
Vue.component("FormWater2", () => import("../products/Energieausweis/formular/BA/partials/FormWater2"));
Vue.component("FormHeatingAdditionalInformations", () => import("../products/Energieausweis/formular/BA/partials/FormHeatingAdditionalInformations"));
Vue.component("FormWWAdditionalInformations", () => import("../products/Energieausweis/formular/BA/partials/FormWWAdditionalInformations"));
Vue.component("FormWW2AdditionalInformations", () => import("../products/Energieausweis/formular/BA/partials/FormWW2AdditionalInformations"));
Vue.component("FormBaOptionalQuestions", () => import("../products/Energieausweis/formular/BA/partials/FormBaOptionalQuestions"));
Vue.component("FormVentilationCheckbox", () => import("../products/Energieausweis/formular/form-partials/FormVentilationCheckbox"));
Vue.component("EMailInput", () => import("../products/Energieausweis/formular/form-partials/EMailInput"));
Vue.component("StepsBar", () => import("../products/Energieausweis/formular/partials/stepsBar"));
Vue.component("QrCodeModal", () => import("../products/Energieausweis/formular/form-partials/QrCodeModal"));
Vue.component("CompleteFormLaterModal", () => import("../products/Energieausweis/formular/partials/completeFormLaterModal.vue"));
Vue.component("AuthDashboard", () => import("../products/auth/AuthDashboard"));
Vue.component("AuthEnergieausweisEdit", () => import("../products/auth/orders/EditEnergieausweis"));
Vue.component("NotionPage", () => import("../global/partials/NotionPage.vue"));
Vue.component("box-toggleable", () => import("../app_immobilienwerker_de/partials/boxToggleable.vue"));
Vue.component("stepper", () => import("../products/Energieausweis/formular/partials/stepper.vue"));

Vue.component("Page1", () => import("../products/Energieausweis/pdf_partials/Page1.vue"));
Vue.component("Page2", () => import("../products/Energieausweis/pdf_partials/Page2.vue"));
Vue.component("Page3", () => import("../products/Energieausweis/pdf_partials/Page3.vue"));
Vue.component("Page4", () => import("../products/Energieausweis/pdf_partials/Page4.vue"));
Vue.component("Page5", () => import("../products/Energieausweis/pdf_partials/Page5.vue"));

Vue.component("find_correct_ea", () => import("../products/Energieausweis/partials/find_correct_ea.vue"));
Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});

Vue.use(GmapVue, {
  load: {
    // [REQUIRED] This is the unique required value by Google Maps API
    key: process.env.MIX_GOOGLE_PLACES_API_KEY,
    // [OPTIONAL] This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    libraries: "places,geometry,Geocoder",

    // [OPTIONAL] If you want to set the version, you can do so:
    v: "3.26",

    // This option was added on v3.0.0 but will be removed in the next major release.
    // If you already have an script tag that loads Google Maps API and you want to use it set you callback
    // here and our callback `GoogleMapsCallback` will execute your custom callback at the end; it must attached
    // to the `window` object, is the only requirement.
    customCallback: "MyCustomCallback"
  },

  // [OPTIONAL] If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  autoBindAllEvents: false,

  // [OPTIONAL] If you want to manually install components, e.g.
  // import {GmapMarker} from 'gmap-vue/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,

  // Load the Google Maps API dynamically, if you set this to `true` the plugin doesn't load the Google Maps API
  dynamicLoad: true
});

if (process.env.MIX_APP_ENV === "production") {

  Sentry.init({
    Vue,
    dsn: "https://972668f463e9f5bd73728b605471c44d@o4507264403046400.ingest.de.sentry.io/4507264405143632",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(
        {
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
          minReplayDuration: 15000
        }
      )
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets:
      [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    denyUrls: denyUrls,
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error?.message && ignoredErrors.some(ignored => error.message.includes(ignored))) {
        return; // Suppress the event
      }
      return event;
    }
  });
}

// AdWords aktiviert auf dieser Seite?
if (process.env.MIX_GOOGLE_ADWORDS_ACCOUNT) {
  Vue.use(VueGtag,
    {
      config: {
        id: process.env.MIX_GOOGLE_ADWORDS_ACCOUNT
      },

      // enabled: false ( mit this.$gtag.config({enabled: true}) aktivieren)
      // disableScriptLoad: false,
      bootstrap: false,
      appName: "Immobilienwerker",
      pageTrackerScreenviewEnabled: false
      // pageTrackerEnabled: true,
      // pageTrackerScreenviewEnabled: true,
    }, router);
}

const app = new Vue({
  el: "#app",
  router,
  pinia
});

// AdWords aktiviert auf dieser Seite?
if (process.env.MIX_GOOGLE_ADWORDS_ACCOUNT) {
  // CookieScript loaded?
  window.addEventListener("CookieScriptLoaded", function() {
    // Default MS content mode
    try {
      window.uetq = window.uetq || [];
      window.uetq.push("consent", "default", {
        "ad_storage": "denied"
      });
    } catch (e) {
      console.error("Allgemeiner Fehler:", e);
    }

    const consentState = CookieScript.instance.currentState();
    if (consentState.action === "accept") {
      bootstrap().then((gtag) => {
        if (!app.isProduction()) console.log("[DEV] 🍪 gtag geladen, da cookies bereits akzeptiert wurden");
      });
    }
    if (consentState.action === "reject") {
      bootstrap().then((gtag) => {
        if (!app.isProduction()) console.log("[DEV] 🍪❌ gtag nicht geladen, da cookies nicht akzeptiert wurden");
      });
    }

    // Cookies Accepted
    window.addEventListener("CookieScriptAcceptAll", function(e) {
      app.cookieAccept()  // Zugriff auf die Methode innerhalb der Vue-Instanz
        .then(() => {
          if (!app.isProduction()) console.log("[DEV] 🍪 Consent aktiviert");
        });
    });
    window.addEventListener("CookieScriptAccept", function(e) {
      app.cookieAccept()  // Zugriff auf die Methode innerhalb der Vue-Instanz
        .then(() => {
          if (!app.isProduction()) console.log("[DEV] 🍪 Consent aktiviert");
        });
    });

    // Cookies Reject
    window.addEventListener("CookieScriptReject", function() {
      app.cookieReject();
      if (!app.isProduction()) console.log("[DEV] 🍪❌ Consent rejected");
    });
  });
}
